<template>
    <div>
        <div class="t-page" v-show="isSuccess == false">
            <div class="banner">
                <img src="https://resources.holowits.com.sg/HC/97ab7bb899a877918bc2ecbf6efa7adf.jpg" alt="">
                <p style="color: #000000; font-size: 11px;">*请一线为回国客户团组填写申请。</p>
                <p style="color: #000000; font-size: 11px;">*Please fill in the application form for the national customer group by the Frontline manager.</p>
                <p style="color: #000000; font-size: 11px;">*陪同人员应为9月18日和19日实际陪同客户团组在上海参观的同事。</p>
                <p style="color: #000000; font-size: 11px;">*The accompanying personnel should be the colleagues who actually accompany the customer group to visit Shanghai on September 18th and 19th.</p>
                <p style="color: #000000; font-size: 11px;">*提单人即本需求单填写人。</p>
                <p style="color: #000000; font-size: 11px;">*Submitter is the person who fills in this requirement form.</p>
            </div>
            <el-form label-position="top" label-width="80px" :model="form" :rules="rules" ref="form">
                <div class="title first">
                    <!-- {{ international[language].title1 }} -->
                    基础信息 Basic Information
                </div>
                <el-form-item label="区域 Region" prop="area">
                    <el-select v-model="form.area" filterable style="width: 100%;">
                        <el-option label="亚太 Asia Pacific" value="亚太"></el-option>
                        <el-option label="中东中亚 Middle East" value="中东中亚"></el-option>
                        <el-option label="北非 North Africa" value="北非"></el-option>
                        <el-option label="南非 South Africa" value="南非"></el-option>
                        <el-option label="欧洲 Europe" value="欧洲"></el-option>
                        <el-option label="拉美 Latin America" value="拉美"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="国家 Country" prop="country">
                    <el-input v-model="form.country"/>
                </el-form-item>
                <el-form-item label="客户名称 Customer Name" prop="companyName">
                    <el-input v-model="form.companyName"/>
                </el-form-item>
                <el-form-item label="客户行业 Customer Industry" prop="industry">
                    <el-select v-model="form.industry" filterable style="width: 100%;">
                        <el-option label="安平 Safe City" value="安平"></el-option>
                        <el-option label="交通 Transportation" value="交通"></el-option>
                        <el-option label="公共事业 Public Utilities" value="公共事业"></el-option>
                        <el-option label="教育 Education" value="教育"></el-option>
                        <el-option label="金融 Finance" value="金融"></el-option>
                        <el-option label="医疗 Healthcare" value="医疗"></el-option>
                        <el-option label="电力 Electric Power" value="电力"></el-option>
                        <el-option label="能源 Energy" value="能源"></el-option>
                        <el-option label="制造 Manufacturing" value="制造"></el-option>
                        <el-option label="互联网服务提供商 ISP" value="ISP"></el-option>
                        <el-option label="中小企业 SMEs" value="中小企业"></el-option>
                        <el-option label="其他 Other" value="其他"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="客户人数 Number of Customers" prop="numberOfPeople">
                    <el-input v-model="form.numberOfPeople"/>
                </el-form-item>
                <el-form-item label="陪同人员（姓名，工号）Accompanying Personnel (Name, Employee ID)" prop="accompanyingPerson">
                    <el-input type="textarea" v-model="form.accompanyingPerson"/>
                </el-form-item>
                <el-form-item label="提单人（姓名，工号）Submitter (Name, Employee ID)" prop="submiter">
                    <el-input type="textarea" v-model="form.submiter"/>
                </el-form-item>
                <el-form-item label="机会点描述 Opportunity Description">
                    <el-input v-model="form.opportunity"/>
                </el-form-item>
                <el-form-item label="交流重点 Key Discussion Points">
                    <el-input v-model="form.communication"/>
                </el-form-item>
                <div class="title first">
                    为客户挑选商业活动 Choose business activities for customers
                </div>
                <el-form-item label="HOLOWITS 2025 秋季新品发布会 HOLOWITS Autumn 2025 New Product Launch" prop="newProductLaunchTime">
                    <el-select v-model="form.newProductLaunchTime" filterable style="width: 100%;">
                        <el-option label="不参与 Not Participate" value="不参与"></el-option>
                        <el-option label="9月18日：13:30-15:40" value="9月18日：13:30-15:40"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="参观HOLOWITS产品和方案展示活动 Exhibition Session" prop="exhibitionTime">
                    <el-select v-model="form.exhibitionTime" filterable style="width: 100%;">
                        <el-option label="不参与 Not Participate" value="不参与"></el-option>
                        <el-option label="9月18日：09:00-10:00" value="9月18日：09:00-10:00"></el-option>
                        <el-option label="9月18日：10:00-11:00" value="9月18日：10:00-11:00"></el-option>
                        <el-option label="9月18日：11:00-12:00" value="9月18日：11:00-12:00"></el-option>
                        <el-option label="9月18日：12:00-13:00" value="9月18日：12:00-13:00"></el-option>
                        <el-option label="9月18日：13:00-14:00" value="9月18日：13:00-14:00"></el-option>
                        <el-option label="9月18日：14:00-15:00" value="9月18日：14:00-15:00"></el-option>
                        <el-option label="9月18日：15:00-16:00" value="9月18日：15:00-16:00"></el-option>
                        <el-option label="9月18日：16:00-17:00" value="9月18日：16:00-17:00"></el-option>
                        <el-option label="9月18日：17:00-18:00" value="9月18日：17:00-18:00"></el-option>
                        <el-option label="9月19日：09:00-10:00" value="9月19日：09:00-10:00"></el-option>
                        <el-option label="9月19日：10:00-11:00" value="9月19日：10:00-11:00"></el-option>
                        <el-option label="9月19日：11:00-12:00" value="9月19日：11:00-12:00"></el-option>
                        <el-option label="9月19日：12:00-13:00" value="9月19日：12:00-13:00"></el-option>
                        <el-option label="9月19日：13:00-14:00" value="9月19日：13:00-14:00"></el-option>
                        <el-option label="9月19日：14:00-15:00" value="9月19日：14:00-15:00"></el-option>
                        <el-option label="9月19日：15:00-16:00" value="9月19日：15:00-16:00"></el-option>
                        <el-option label="9月19日：16:00-17:00" value="9月19日：16:00-17:00"></el-option>
                        <el-option label="9月19日：17:00-18:00" value="9月19日：17:00-18:00"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预约高层或高级专家同客户交流 Executive Exchange" prop="exchangeTime">
                    <el-select v-model="form.exchangeTime" filterable style="width: 100%;">
                        <el-option label="不参与 Not Participate" value="不参与"></el-option>
                        <el-option label="9月18日：09:00-10:00" value="9月18日：09:00-10:00"></el-option>
                        <el-option label="9月18日：10:00-11:00" value="9月18日：10:00-11:00"></el-option>
                        <el-option label="9月18日：11:00-12:00" value="9月18日：11:00-12:00"></el-option>
                        <el-option label="9月18日：12:00-13:00" value="9月18日：12:00-13:00"></el-option>
                        <el-option label="9月18日：13:00-14:00" value="9月18日：13:00-14:00"></el-option>
                        <el-option label="9月18日：14:00-15:00" value="9月18日：14:00-15:00"></el-option>
                        <el-option label="9月18日：15:00-16:00" value="9月18日：15:00-16:00"></el-option>
                        <el-option label="9月18日：16:00-17:00" value="9月18日：16:00-17:00"></el-option>
                        <el-option label="9月18日：17:00-18:00" value="9月18日：17:00-18:00"></el-option>
                        <el-option label="9月19日：09:00-10:00" value="9月19日：09:00-10:00"></el-option>
                        <el-option label="9月19日：10:00-11:00" value="9月19日：10:00-11:00"></el-option>
                        <el-option label="9月19日：11:00-12:00" value="9月19日：11:00-12:00"></el-option>
                        <el-option label="9月19日：12:00-13:00" value="9月19日：12:00-13:00"></el-option>
                        <el-option label="9月19日：13:00-14:00" value="9月19日：13:00-14:00"></el-option>
                        <el-option label="9月19日：14:00-15:00" value="9月19日：14:00-15:00"></el-option>
                        <el-option label="9月19日：15:00-16:00" value="9月19日：15:00-16:00"></el-option>
                        <el-option label="9月19日：16:00-17:00" value="9月19日：16:00-17:00"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <div class="t-input" style="display: flex; justify-content: center;">
                <el-button round style="background-color: #c7000b; color: #ffffff; width: 160px;" :loading="isLoading" @click="add">Submit</el-button>
            </div>
        </div>
        <div v-show="isSuccess === true" style="text-align: center;">
            <img src="https://resources.holowits.com.sg/HC/shanghai%202.jpg" width="100%" alt="">
        </div>
    </div>
</template>
  
<script>
  import countrys from '@/utils/country.json';
  import {save} from '@/api/otherFormApi';
  export default {
    name: 'ShanghaiInternalIndex',
  data() {
      return {
          isSuccess: false,
          language: 'en',
          activity1: false,
          activity2: false,
          activity3: false,
          activity5: false,
          activity6: false,
          form: {
            area: '',
            country: '',
            companyName: '',
            industry: '',
            numberOfPeople: '',
            accompanyingPerson: '',
            submiter: '',
            opportunity: '',
            communication: '',
            newProductLaunchTime: '',
            exhibitionTime: '',
            exchangeTime: '',
            source: ''
          },
          rules: {
            area: [{required: true, message: 'required', trigger: 'change'}],
            country: [{required: true, message: 'required', trigger: 'blur'}],
            companyName: [{required: true, message: 'required', trigger: 'blur'}],
            industry: [{required: true, message: 'required', trigger: 'change'}],
            numberOfPeople: [{required: true, message: 'required', trigger: 'blur'}],
            accompanyingPerson: [{required: true, message: 'required', trigger: 'blur'}],
            submiter: [{required: true, message: 'required', trigger: 'blur'}],
            newProductLaunchTime: [{required: true, message: 'required', trigger: 'change'}],
            exhibitionTime: [{required: true, message: 'required', trigger: 'change'}],
            exchangeTime: [{required: true, message: 'required', trigger: 'change'}],
          },
          countryArr: [],
          isLoading: false,
          hasError: false
      }
  },
  created() {
      this.countryArr = countrys.country.map(item => {
          return {label: item, value: item}
      })
  },
//   watch: {
//     form: {
//         handler(n, v) {
//             let checkList = Object.keys(n)
//             for (let key of checkList) {
//                 this.check(key, n[key])
//             }
//         },
//         deep: true
//     }
//   },
  methods: {
    check(key, value) {
        if (key in this.rules) {
            return this.rules[key] = (value ? false : true);
        }
    },
     async add() {
        try {
            await this.$refs.form.validate()
            this.form['source'] = 'shanghai-internal-2025'
            this.isLoading = true
            const {data: {data, isSuccess}} = await save({
                content: JSON.stringify(this.form),
                pageSource: 'shanghai-internal-2025'
            })
            if (isSuccess) {
                this.isSuccess = true
                this.isLoading = false
            } else {
                this.isLoading = false
            }
        } catch(e) {
            this.isLoading = false
        }
        
    }
  }
  }
</script>
  
<style lang="less" scoped>
  .t-page {
    padding-bottom: 30px;
  }
  .banner {
      width: 100%;
      img {
          width: 100%;
      }
  }
  .error-info {
      color: red;
      font-size: 12px;
  }
  .company-icon {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
  
      .left {
          width: 163px;
          height: 80px;
      }
      .line {
          height: 40px;
          width: 2px;
          background-color: #000000;
      }
      .right {
          width: 105px;
          height: 105px;
      }
  }
  .first {
      margin-top: 20px;
  }
  
  .title {
      font-size: 18px;;
      font-weight: 600;
      margin-bottom: 20px;
  }
  .require {
    &::after {
        content: '*';
        padding-left: 2px;
        color: #c7000b;
    }
  }

  /deep/.el-form-item__label {
    font-size: 12px;
    color: #C0C4CC;
    font-weight: 500;
    display: inline-block;
    padding-bottom: 5px;
    line-height: 100%;
  }

  .t-input {
      margin-bottom: 20px;
      position: relative;

      .t-label {
          position: absolute;
          font-size: 14px;
          top: 10px;
          left: 16px;
          background-color: #ffffff;
          color: #C0C4CC;
          transition: all 0.4s;
  
          &::after {
              content: '*';
              padding-left: 2px;
              color: #c7000b;
          }
      }
      .optional {
          &::after {
              content: '';
          }
      }
      .focus {
          padding: 0 5px;
          top: -12px;
          font-size: 12px;
      }
    //   .focus2 {
    //       padding: 0 5px;
    //       top: -12px;
    //       left: 12px;
    //       font-size: 12px;
    //   }
      .el-input__inner:focus+.t-label {
          padding: 0 5px;
          top: -12px;
          font-size: 12px;
      }
  }
  .error {
    ::v-deep input {
        border-color: rgb(199, 0, 11) !important;
    }
    ::v-deep textarea {
        border-color: rgb(199, 0, 11) !important;
    }
  }
  @media only screen and (min-width: 992px) {
      .t-page {
          max-width: 838px;
          margin: 20px auto;
      }
  }
  @media only screen and (max-width: 991px) {
      .t-page {
          width: 100%;
          margin: 20px auto;
          padding: 15px;

          ::v-deep .h60 {
            .el-input__inner {
                height: 60px;
            }
          }
          .t-label {
            right: 25px;
          }
        //   .h60 + .t-label {
        //     top: 2px;
        //     bottom: 2px;
        //   }
        //   .t-label {
        //         position: absolute;
        //         font-size: 14px;
        //         top: 10px;
        //         left: 16px;
        //         background-color: #ffffff;
        //         color: #C0C4CC;
        //         transition: all 0.4s;
        
        //         &::after {
        //             content: '*';
        //             padding-left: 2px;
        //             color: #c7000b;
        //         }
        //     }
          .focus {
            padding: 0 5px;
            top: -10px;
            font-size: 8px;
          }
      }
  }
</style>